import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { heroBadges, heroStats, BUNDLE_MOCKUP } from '../data/offer';
const TRUST = [{
  icon: LockIcon,
  label: 'Secure SSL payment'
}, {
  icon: ZapIcon,
  label: 'Instant access'
}, {
  icon: ShieldCheckIcon,
  label: '30-day guarantee'
}];
export function Hero() {
  return <header className="w-full border-b border-line bg-cream" data-id="element-134" data-mp="1297a3xzwwp6o">
      <div className="mx-auto max-w-6xl px-4 pb-12 pt-10 text-center sm:px-5 sm:pb-14 sm:pt-20" data-id="element-135" data-mp="128pft6wt8l1e">
        <p className="font-sans text-[10px] font-bold uppercase tracking-[0.24em] text-terracotta sm:text-[11px] sm:tracking-[0.3em]" data-id="element-136" data-mp="xb5qnbykqnuo">
          The Perfect Dog Method™
        </p>

        <h1 className="mx-auto mt-5 max-w-4xl font-display text-[1.85rem] font-semibold leading-[1.1] tracking-[-0.02em] text-ink sm:mt-7 sm:text-5xl sm:leading-[1.05] lg:text-[4.25rem]" data-id="element-137" data-mp="nbop96qcuw4i">
          How to transform your “problem dog” into a calm, obedient companion in{' '}
          <span className="italic text-terracotta" data-id="element-138" data-mp="3j897lcz58bpj">just 30 days…</span>
        </h1>

        <p className="mx-auto mt-4 max-w-2xl font-display text-lg italic leading-snug text-muted sm:mt-6 sm:text-2xl" data-id="element-139" data-mp="3o85b7b3xi14k">
          Even if you’ve tried everything and nothing seems to work.
        </p>

        <p className="mx-auto mt-4 max-w-2xl text-[15px] leading-relaxed text-ink/75 sm:mt-6 sm:text-lg" data-id="element-140" data-mp="3e8wjyq0g70lw">
          Stop the barking, pulling, and chaos. Start enjoying your dog again
          with a simple 15-minute daily system.
        </p>

        <img src={BUNDLE_MOCKUP} alt="The Perfect Dog Method on tablet and phone, surrounded by the five bonus guides" className="mx-auto mt-8 w-full max-w-[19rem] sm:mt-10 sm:max-w-md lg:max-w-lg" data-id="element-141" data-mp="35aawqhk16xes" />

        <ul className="mx-auto mt-8 flex max-w-3xl flex-wrap justify-center gap-1.5 sm:mt-10 sm:gap-2" data-id="element-142" data-mp="2hj5ig6tqod6l">
          {heroBadges.map(badge => <li key={badge} className="rounded-full border border-terracotta/25 bg-terracotta-soft px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.1em] text-terracotta-dark sm:px-3.5 sm:py-2 sm:text-[11px] sm:tracking-[0.12em]" data-id="element-143" data-mp="2ljgzzaqt1xdu">
              {badge}
            </li>)}
        </ul>

        <div className="mt-8 flex flex-col items-center sm:mt-10" data-id="element-144" data-mp="i9vuleaj4iql">
          <CtaButton size="lg" data-id="element-145" data-mp="deq40266mfw6">Yes! I want a perfect dog for $25</CtaButton>
          <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-[11px] font-medium text-muted sm:text-xs" data-id="element-146" data-mp="1azumdhg3ytyy">
            {TRUST.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-1.5" data-id="element-147" data-mp="1126nqgfdt2bi">
                <Icon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-148" data-mp="114kjkrhvyik4" />
                <span className="whitespace-nowrap" data-id="element-149" data-mp="x0uwy7krub1q">{label}</span>
              </li>)}
          </ul>
        </div>
      </div>

      <div className="border-t border-line bg-white" data-id="element-150" data-mp="3hrllolqr8dak">
        <dl className="mx-auto grid max-w-6xl grid-cols-2 sm:grid-cols-4 sm:divide-x sm:divide-line" data-id="element-151" data-mp="3hpsg79rvnz45">
          {heroStats.map(stat => <div key={stat.label} className="border-b border-line px-4 py-5 text-center sm:border-b-0 sm:px-6 sm:py-7" data-id="element-152" data-mp="21amwtbz2vwne">
              <dt className="sr-only" data-id="element-153" data-mp="268odxrcy1lw8">{stat.label}</dt>
              <dd data-id="element-154" data-mp="2b192oegzt8sw">
                <span className="block font-display text-xl font-semibold leading-none text-terracotta sm:text-3xl" data-id="element-155" data-mp="2b1hjuik5f09w">
                  {stat.value}
                </span>
                <span className="mt-2 block text-[11px] leading-snug text-muted sm:text-[13px]" data-id="element-156" data-mp="2kyduattlxwh3">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </header>;
}